import { CSSObject } from "@emotion/react";
import { IonIcon } from "@ionic/react";
import { checkmark } from "ionicons/icons";

import { NegativeData } from "~components/ModalSubFeedback";
import {
  ModalSubFeedbackBody,
  ModalSubFeedbackFooter,
  ModalSubFeedbackHeader,
} from "~components/ModalSubFeedback/ModalSubFeedback";
import { translate } from "~utils";

const styles: Record<string, CSSObject> = {
  bodyContainer: {
    display: "flex",
    flex: 4,
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 24,
    textAlign: "center",
    gap: 8,
  },
  safetyBody: {
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    gap: 8,
  },
  link: {
    textDecoration: "none",
    fontWeight: 500,
  },
  ionIcon: {
    fontSize: 64,
    color: "green",
  },
};

type ModalSubFeedbackContentNegativeSummaryProps = {
  negativeData: NegativeData;
  onDismiss: () => void;
  subName?: string;
  schoolName: string;
};

export function ModalSubFeedbackContentNegativeSummary(
  props: ModalSubFeedbackContentNegativeSummaryProps,
) {
  const { onDismiss, negativeData, subName, schoolName } = props;
  const { reasons, isBlocked } = negativeData;

  return (
    <>
      <ModalSubFeedbackHeader title={translate("FEEDBACK_SUBMITTED_LABEL")} onDismiss={onDismiss} />
      <ModalSubFeedbackBody>
        <div css={styles.bodyContainer}>
          <IonIcon slot="icon-only" icon={checkmark} css={styles.ionIcon} />
          <h3>{translate("MSF_SUMMARY_TITLE")}</h3>
          {/* Sub is blocked */}
          {isBlocked && <p>{translate("MSF_NEGATIVE_SUMMARY_BLOCKED", { subName, schoolName })}</p>}
          {/* Sub has Safety Reason */}
          {reasons.includes("REASON_SAFETY") && (
            <div css={styles.safetyBody}>
              <p>{translate("MSF_NEGATIVE_SUMMARY_SAFETY")}</p>
              <span>
                {translate("MSF_NEGATIVE_SUMMARY_CONTACT")}
                <a css={styles.link} href="tel:+16504139268">
                  {translate("SUPPORT_PHONE")}
                </a>
                .
              </span>
            </div>
          )}
          {/* Sub is blocked but not for safety reason */}
          {isBlocked && !reasons.includes("REASON_SAFETY") && (
            <p>{translate("MSF_NEGATIVE_SUMMARY_REVIEW")}</p>
          )}
          {/* Sub is not blocked and reason is not safety */}
          {!isBlocked && !reasons.includes("REASON_SAFETY") && (
            <p>{translate("MSF_NEGATIVE_SUMMARY_DEFAULT")}</p>
          )}
        </div>
      </ModalSubFeedbackBody>
      <ModalSubFeedbackFooter
        buttonPrimary={{ onClick: onDismiss, isDisabled: false, text: "Close" }}
      />
    </>
  );
}
